export const GOOGLE_COURSERA_XDP_PROMOTION_SLUGS = [
  'google-data-analytics',
  'google-digital-marketing-ecommerce',
  'google-it-automation',
  'google-it-support',
  'google-project-management',
  'google-ux-design',
  'google-advanced-data-analytics',
  'google-business-intelligence',
  'google-cybersecurity',
  'prompting-essentials-google',
  'ai-essentials-google',
];
